import './mdTimePicker.scss'
import templateUrl from './mdTimePicker.html'

/**
 * Modifies mdTimePicker from angular-material-time-picker.
 *
 * @type {ngDecorator}
 */
function mdTimePickerDirectiveDecorator($delegate) {
  'ngInject'
  $delegate[0].templateUrl = templateUrl // Use our template system.
  delete $delegate[0].template

  // Add attributes.
  $delegate[0].scope.hasValue = '<?'
  $delegate[0].scope.hideSelects = '<?'

  return $delegate
}

export let decorator = ['mdTimePickerDirective', mdTimePickerDirectiveDecorator]
